import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/business man 1.png")